import LinearGradientBackground, { LinearGradientBackgroundColors, LinearGradientBackgroundPatterns } from 'components/atoms/LinearGradientBackground';
import _ from "lodash";
import { useEffect, useState } from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { useSelector } from 'react-redux';
import { dataConstants } from 'services/redux/data/constants';
import { ThemedValues } from 'styles/themed';
import Text from 'theme/Text';
import HelperFileCache from 'utils/HelperFileCache';
import { colorList } from 'utils/colors';
import { settingsConstants } from 'utils/constants/settings-constants';
import HelperSetting from 'utils/helper-setting';
import i18n from 'utils/i18n';
import { useSafeAreaInsets } from 'react-native-safe-area-context'

const SplashLogoBanner = ( { slowConnection = false }) => {

	const _settings = useSelector( state => {
		return state.data[dataConstants.SETTINGS];
	} )
	const insets = useSafeAreaInsets();
	
	const [ image, setImage ] = useState( null );
	
	const findInSettings = () => {
		let splashBackground = HelperSetting.get( settingsConstants.LOGO_URL, null );
		
		if( splashBackground !== null ){
			let cached_extension = HelperFileCache.getExtension( splashBackground );
			let cached_filename = HelperFileCache.prepareFilename( `${HelperFileCache.getFilename( splashBackground ).replace(`.${cached_extension}`,'')}___logo.${cached_extension}` );
			
			if( _.isString( image ) && image.includes( 'file://') && image !== cached_filename ){
				HelperFileCache.deleteFile( image ).then( () => {
				} );
			}
			
			HelperFileCache.create( splashBackground, cached_filename ).then( result => {
				setImage( result );
			});
		}
	}
	
	const findInCacheByExtensions = ( extensions ) => {
		let extension = extensions.shift();
		
		HelperFileCache.findFiles( `*___logo.${ extension }` ).then( filenames => {
			if( filenames.length > 0 ) {
					setImage( filenames[ 0 ] );
			}else if( extensions.length > 0 ){
				findInCacheByExtensions( extensions );
			}
		});
	}
	
	useEffect( () => {
		if( HelperSetting.isReady() ){
			findInSettings();
		}else{ // No settings try to find a splash.mp4
			findInCacheByExtensions( [ 'png', 'jpg' ] );
		}
		
	}, [ _settings ]);
	
	return (
		<View 
			style={[ styles.loadingLogoContainer, { paddingBottom: insets.bottom || 20 } ]} >

			{ slowConnection && (
				<View style={ styles.slowConnection }>
					<Text style={ styles.slowConnectionText }>{i18n.t( 'pages.loading.slow_connection')}</Text>
				</View>
			)}
			
			{ image !== null && (
				<Image 
					source={ { uri: image }} 
					style={ styles.loadingLogo} 
					resizeMode="contain" 
				/>
			)}
			
			<Text 
				style={ styles.loadingPoweredBy }>
					
				{ i18n.t( 'ui.powered_by' ) }{ ' ' }<Text style={ styles.loadingPoweredByMOD }>{ i18n.t('app_name') }</Text>
			</Text>
		</View>
	);
}

const styles = StyleSheet.create({
	loadingLogoContainer: {
		width: '100%',
		padding: 20,
		flexDirection: 'column',
		justifyContent: 'flex-end',
		backgroundColor: colorList.WHITE.primary,
	},
	loadingLogo: {
		width: '100%',
		padding: 0,
		height: 70,
		marginBottom: 12
	},
	loadingImage: {
		width: '100%',
		height: '100%',
	},
	loadingPoweredBy: {
		color: colorList.TEXT.primary,
		fontWeight: '700',
		textAlign: 'center'
	},
	loadingPoweredByMOD: {
		color: colorList.ORANGE.primary,
		fontWeight: '700',
	},
	slowConnection: {
		opacity: 0.95,
		backgroundColor: colorList.PRIMARY.primary,
		position: 'absolute',
		left: 0,
		right: 0,
		height: 50,
		top: -50,
		borderTopRightRadius: 10,
		borderTopLeftRadius: 10,
		alignItems: 'center',
		justifyContent: 'center'
	},
	slowConnectionText: {
		color: colorList.WHITE.primary,
		fontWeight: '700',
		fontSize: 12,
		textDecorationLine: 'underline',
		textAlign: 'center'
	}
})

export default SplashLogoBanner;